

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://18d2f96d279149989b95faf0a4b41882@sentry-next.wixpress.com/1784", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/125829a590a0b31a/packages/form-app/src/components/Form/Widget/index.tsx';
    import createController from '/home/builduser/work/125829a590a0b31a/packages/form-app/src/components/Form/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    import { createErrorHandler } from '@wix/yoshi-flow-editor/runtime/esm/error-handler/createErrorHandler';
    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa/cssVars';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'Form';
    var projectName = 'form-app';
    var sentryConfig = {
      DSN: 'https://18d2f96d279149989b95faf0a4b41882@sentry-next.wixpress.com/1784',
      id: '5d1795a2db124a268f1e1bd88f503500',
      projectName: 'form-app',
      teamName: 'forms',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/125829a590a0b31a/packages/form-app/src/components/Form/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":[]};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/125829a590a0b31a/packages/form-app/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"settings_inputStyle":"Input style","settings_design_buttons_uploadButton":"Upload Button","settings_distance":"Distance","settings_support_customizing":"Customizing my form","settings_selectionColor":"Checked option color","settings_errorMessage":"Error color","settings_preset_button":"Set","settings_topAndBottomPadding":"Top and bottom padding","settings_design_submitButton":"Submit button","settings_colorAndOpacity":"Color & opacity","settings_state_regular":"Regular","settings_formNotFound":"No results for “{search}”","settings_state_error":"Error","settings_buttons_hover":"Hover","emptyState_lineTwo":"Go to Form Settings > Forms tab","ai_assistant_actions_submit":"Submit","settings_fontStyleAndColor":"Font style & color","settings_fieldTitle":"Field title style & color","settings_submitButton_hover":"Hover","settings_headerOneStyleAndColor":"Header 1 style & color","ai_assistant_error_message":"There was an error on our end. Refresh and try again.","settings_state_focus":"Focus","settings_textStyleAndColor":"Text style & color","settings_fontPicker":"Font picker","ai_assistant_input_placeholder":"Write your message","settings_search":"Search","settings_shadowColorAndOpacity":"Shadow color & opacity","settings_manage_description":"Review submissions, create forms and update settings.","settings_support_contactCustomerCare":"Contact Customer Care","settings_support_technicalProblems":"Technical problems? Troubleshoot common errors and issues.","settings_forms_error_title":"We couldn't load the form settings","settings_border_bottom":"Bottom","settings_state_hover":"Hover","settings_createForm":"Create Form","settings_textFormatting_italic":"Italic","settings_headers":"Headers","settings_design_inputFields":"Form Fields","settings_size":"Size","ai_assistant_skip_button":"Skip","settings_linkColor":"Link text color","settings_support_helpCenter":"Help Center","panels_upgradeModal_title":"You’ve reached your form limit ","settings_headerTwoStyleAndColor":"Header 2 style & color","settings_fieldTitlePadding":"Field title padding","settings_textFormatting_underline":"Underline","settings_design_buttons_nextButton":"Next Button","settings_support_seeAll":"See All Articles","settings_textColor":"Text color","settings_paragraphText":"Paragraph text","emptyState_title":"Add a form","settings_fieldNoteSize":"Field note size","settings_input":"Input style & color","settings_forms_error_subtitle":"There was a technical issue on our end. Refresh and try again.","settings_design_buttons_previousButton":"Back Button","settings_inputFields":"Form field style","settings_border_allSides":"All sides","settings_placeholderColor":"Placeholder text color","settings_angle":"Angle","settings_upgrade_title":"Upgrade your plan","settings_state":"State","settings_manage_manage":"Manage Forms","settings_borderWidth":"Border width","settings_layout_topAndBottomPadding":"Top and bottom padding","settings_cornerRadius":"Corner radius","settings_design_texts":"Header and Paragraph","settings_blur":"Blur","ai_assistant_multi_choice_submit":"Continue","settings_support_editFormFields":"Edit my form fields","settings_tab_manage":"Manage","gfpp_chooseForm":"Choose Form","ai_assistant_actions_skip":"Skip question","settings_buttons_regular":"Regular","settings_back":"Back","settings_layout_spacingBetweenRows":"Spacing between rows","settings_tab_layout":"Layout","settings_textAlignment":"Text alignment","settings_textFormatting_label":"Text style","settings_fieldNote":"Field description style & color","settings_border_none":"None","ai_assistant_skip_message":"Skip this question","settings_design_buttons_fields":"Form field buttons","settings_inputFieldLayout":"Form Fields","settings_fontSize":"Font size","ai_assistant_progress":"Form progress","settings_spaceBetweenFieldAndFieldTitle":"Space between field and field title","settings_tab_design":"Design","ai_assistant_button":"Help me fill in the form","settings_support_gotQuestion":"Got a question?","settings_upgrade_item2":"Accept file uploads like images and documents","settings_forms_emptyState_title":"Create a form","settings_submitButton_regular":"Regular","ai_assistant_header_description":"Fill in this form with the help of AI chat","panels_upgradeModal_secondaryButton":"Maybe Later","settings_support_technicalAssist":"Wix Technical Assistant","ai_assistant_error_retry_button":"Try again","settings_manage_title":"Manage forms","settings_formContainerLayout":"Form container","settings_layout_spacingBetweenColumns":"Spacing between columns","settings_upgrade_item3":"Add interactive rules and pages","settings_premium_banner_part1":"To create more forms,","settings_forms_error_retry":"Refresh","settings_support_contact":"Still having issues? Contact us for assistance.","settings_borderColorAndOpacity":"Border color & opacity","settings_preset_name":"Preset name","settings_layout_sidePadding":"Side padding","settings_tab_preset":"Preset","gfpp_editForm":"Edit Form","panels_upgradeModal_subtitle":"Upgrade to a Premium plan to create more forms, get advanced features and collect more info.","settings_resetToOriginalDesign":"Reset to original design","settings_chooseForm":"Choose a form","ai_assistant_actions_end":"End chat & continue","settings_upgrade_button":"Upgrade","settings_textFormatting_bold":"Bold","settings_forms_emptyState_content":"Add a form to get subscribers, capture leads or collect visitor info.","settings_upgrade_item1":"Create more forms for your site","panels_upgradeModal_primaryButton":"Upgrade","settings_design_buttons_submitButton":"Submit Button","settings_limitationRules_warning":"Submission limits have been set for this form.","settings_placeholderPadding":"Placeholder padding","settings_premium_banner_part2":"upgrade your plan.","settings_design_buttons":"Buttons","settings_enableShadow":"Apply shadow","settings_tab_upgrade":"Upgrade","settings_tab_support":"Support","settings_buttonLayout":"Submit Button","settings_design_formBackground":"Form Background","ai_assistant_header_1":"AI FORMS ASSISTANT","settings_fillColorAndOpacity":"Fill color & opacity","emptyState_lineOne":"Choose an existing form or create a new one.","settings_tab_forms":"Forms","disabled_state_section_notification":"This form has expired. To change its limits, go to Form Status settings.","settings_manage_create":"Create Form","settings_inputFieldText":"Form field text"};
    var styleHocConfig = {"enabled":true};
    var biConfig = {"enableUniversalEvents":true};
    var appDefinitionId = "225dd912-7dea-4738-8688-4b8c6955ffc2";
    var componentId = "371ee199-389c-4a93-849e-e35b8a15b7ca";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/125829a590a0b31a/packages/form-app/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createErrorHandler,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
      Sentry: window.Sentry && {
        forceLoad: () => window.Sentry.forceLoad(),
        onLoad: (fn) => window.Sentry.onLoad(() => fn(window.Sentry))
      }
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
